/**
 * La route `/stages` : elle récupère, puis délègue à `CatalogueVue`.
 *
 * La vue est rendue à l'identique au build par `scripts/prerendre.mjs` — c'est
 * pour cela qu'elle vit ailleurs et ne lit rien elle-même.
 */

import { useEffect, useMemo, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { stagesPublics } from '../../lib/seo/gateway.supabase';
import { ORGANISATEUR, filDArianeJsonLd, type StagePublic } from '../../lib/seo/stage';
import { ORIGINE, useEnTete } from '../../lib/seo/enTete';
import CatalogueVue from './CatalogueVue';

const CataloguePublicPage = () => {
  const [stages, setStages] = useState<StagePublic[]>([]);
  const [chargement, setChargement] = useState(true);

  useEffect(() => {
    let vivant = true;
    stagesPublics()
      .then((s) => {
        if (vivant) setStages(s);
      })
      .catch(() => {
        if (vivant) setStages([]);
      })
      .finally(() => {
        if (vivant) setChargement(false);
      });
    return () => {
      vivant = false;
    };
  }, []);

  const donnees = useMemo(
    () =>
      filDArianeJsonLd(
        [
          { nom: 'Accueil', chemin: '/' },
          { nom: 'Stages', chemin: '/stages' },
        ],
        ORIGINE,
      ),
    [],
  );

  useEnTete({
    titre: 'Stages et plaines de vacances pour enfants à Bruxelles | Éclosion',
    description: `${ORGANISATEUR} organise des stages et plaines de vacances pour enfants à Bruxelles. Consultez les dates, les lieux, les âges et les tarifs, et inscrivez votre enfant en ligne.`,
    chemin: '/stages',
    /*
      Un catalogue vide reste indexable : c'est la page d'entrée du site, et
      l'absence temporaire de stage ouvert ne la rend pas sans valeur. Ce sont
      les pages de FILTRE vides que le cahier des charges écarte — et il n'y en
      a pas ici, par construction.
    */
    donnees,
  });

  if (chargement) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-16 flex justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-primary-600" />
      </div>
    );
  }

  return <CatalogueVue stages={stages} />;
};

export default CataloguePublicPage;
